import {active_vm_frame} from '../activeVM.js';
import {observable, autorun} from 'mobx';


// Opens guac's Configure Layout modal from outside the iframe.
// Same reach-in approach as resize.js (Angular scope in the iframe).

// Find clientController scope (has openLayoutEditor). Undefined if no iframe,
// cross-origin, or webconnect build without multi-monitor support.
const getClientScope = () => {

  const iframe = active_vm_frame.get();

  if(!iframe || !iframe.contentWindow || !iframe.contentWindow.angular) return;

  const ng = iframe.contentWindow.angular;

  let scope = ng.element('.display').scope() || ng.element(iframe.contentDocument.body).scope();

  while(scope && !scope.openLayoutEditor) scope = scope.$parent;

  return scope;

};


// Whether Configure Layout is available on the current RDP session.
export const canConfigureLayout = () => {

  try {

    const scope = getClientScope();

    return !!(scope && scope.canConfigureLayout && scope.canConfigureLayout());

  } catch(e) {

    return false;

  }

};


// Opens Configure Layout. No-op if canConfigureLayout() is false.
export const openLayoutEditor = () => {

  try {

    const scope = getClientScope();

    if(scope && scope.canConfigureLayout && scope.canConfigureLayout()) {

      scope.$apply(() => scope.openLayoutEditor());

      return true;

    }

    return false;

  } catch(e) {

    console.log(e);

    return false;

  }

};


// Same iframe reach-in as getClientScope, but returns the Angular injector.
// Tries .display first (matches getClientScope) so it works regardless of where
// ng-app is rooted. Undefined if no iframe / cross-origin / non-multimon build.
const getClientInjector = () => {

  const iframe = active_vm_frame.get();

  if(!iframe || !iframe.contentWindow || !iframe.contentWindow.angular) return;

  const ng = iframe.contentWindow.angular;

  try {
    return ng.element('.display').injector() || ng.element(iframe.contentDocument.body).injector();
  } catch(e) {
    return;
  }

};


// Tell this connection's secondary windows to follow the primary's fullscreen
// state: true shows their consent button (fullscreen needs a per-window gesture),
// false exits them. Scoped per-connection; no-op without a guac client/secondary.
export const triggerGuacFullscreen = (state) => {

  try {

    const injector = getClientInjector();

    if(!injector) return false;

    const guacManageMonitor = injector.get('guacManageMonitor');

    if(guacManageMonitor && typeof guacManageMonitor.pushBroadcastMessage === 'function') {

      guacManageMonitor.pushBroadcastMessage('fullscreen', !!state);

      return true;

    }

    return false;

  } catch(e) {

    console.log('triggerGuacFullscreen failed:', e);

    return false;

  }

};


// Guac connection state isn't observable — poll it for the toolbar button.
// See resize.js / autoclose.js for the same autorun + interval pattern.
export const multimon_available = observable.box(false);

let poll = null;

window.setTimeout(() => autorun(() => {

  // Re-run whenever the active VM switches or closes.
  const iframe = active_vm_frame.get();

  // Hide immediately on switch; the poll below re-enables it once the new
  // connection is ready and actually supports multi-monitor.
  multimon_available.set(false);

  if(poll) { clearInterval(poll); poll = null; }

  if(!iframe) return;

  poll = setInterval(() => multimon_available.set(canConfigureLayout()), 500);

}), 0);
